var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeaderTopTip"},[_c('p',{staticClass:"tip"},[_c('a',{attrs:{"href":"https://x.com/spacefi_io/status/1825837059573223725","target":"_black"}},[_vm._v("Join SpaceFi campaign in ZK Fest, earning 200k $ZK bonus!")])])])
}]

export { render, staticRenderFns }